// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getBidDetailsProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetBidDetailsProfessionalApi = createAsyncThunk(
  "hitGetBidDetailsProfessionalApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + getBidDetailsProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetBidDetailsProfessionalSlice = createSlice({
  name: "getBidDetailsProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetBidDetailsData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetBidDetailsProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetBidDetailsProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetBidDetailsProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetBidDetailsData } = GetBidDetailsProfessionalSlice.actions;
export default GetBidDetailsProfessionalSlice.reducer;
